"use strict";
import SalesRepContainer from 'emun.salesrep/salesrep-container'
import SalesRepList from 'emun.salesrep/salesrep-list'
import SalesRepDashboard from 'emun.salesrep/salesrep-dashboard'
import SubRepDashboard from 'emun.salesrep/subrep-dashboard'
import b2bDashboard from 'emun.salesrep/b2b-dashboard'
import ManagerContainer from 'emun.salesrep/manager-container'
import ManagerList from 'emun.salesrep/manager-list'
import InsideSalesContainer from 'emun.salesrep/inside-sales-container'
import InsideSalesList from 'emun.salesrep/inside-sales-list'
import ManagerDashboard from 'emun.salesrep/manager-dashboard'
import SyncDashboard from 'emun.salesrep/sync-dashboard'
import SalesRepRecentOrders from 'emun.salesrep/salesrep-recent-orders'
import SalesRepReviewOrders from 'emun.salesrep/salesrep-review-orders'
import CreditHoldOrders from 'emun.salesrep/credithold-orders'
import CreditHoldCorporateOrders from 'emun.salesrep/credithold-corporate-orders'
import CreditReviewOrders from 'emun.salesrep/creditreview-orders'
import PastDueInvoices from 'emun.salesrep/pastdue-invoices'
import CustomersPastDue from 'emun.salesrep/customers-pastdue'
import SalesRepSalesGoalsLYChart from 'emun.salesrep/salesrep-sales-goals-ly-chart'
import SalesRepShipmentsGoalsLYChart from 'emun.salesrep/salesrep-shipments-goals-ly-chart'
import SalesRepSalesGoalsVendor from 'emun.salesrep/salesrep-sales-goals-vendor'
import SalesRepProjectedBookings from 'emun.salesrep/salesrep-projected-bookings'
import SalesRepProjectedBookingsThisWeek from 'emun.salesrep/salesrep-projected-bookings-thisweek'
import SalesRepTopCustomers from 'emun.salesrep/salesrep-top-customers'
import SalesRepTopCommitments from 'emun.salesrep/salesrep-top-commitments'
import TopCustomersFull from 'emun.salesrep/top-customers-full'
import SalesRepTopUnderperformers from 'emun.salesrep/salesrep-top-underperformers'
import SalesRepExpectedOrders from 'emun.salesrep/salesrep-expected-orders'
import SalesRepExpectedOrdersFuture from 'emun.salesrep/salesrep-expected-orders-future'
import SalesRepSalesSourceQuarter from 'emun.salesrep/salesrep-sales-source-quarter'
import SalesRepSalesCategoryQuarter from 'emun.salesrep/salesrep-sales-category-quarter'
import custom from 'emun.salesrep/_emun.custom'
import ExecutiveDashboard from 'emun.salesrep/executive-dashboard'
import ShowroomDashboard from 'emun.salesrep/showroom-dashboard'
import SalesrepShowroomDashboard from 'emun.salesrep/salesrep-showroom-dashboard'
import RepGroupDashboard from 'emun.salesrep/repgroup-dashboard'
import InsideSalesDashboard from 'emun.salesrep/inside-sales-dashboard'
import MarketDashboard from 'emun.salesrep/market-dashboard'
import ManagerActionsRep from 'emun.salesrep/manager-actions-rep'
import ManagerReps from 'emun.salesrep/manager-reps'
import ShowAppointmentProjections from 'emun.salesrep/show-appointment-projections'
import ShowDailyAppointments from 'emun.salesrep/show-daily-appointments'
import ShowHourlyAppointments from 'emun.salesrep/show-hourly-appointments'
import ShowDailyComparison from 'emun.salesrep/show-daily-comparison'
import WeekActivities from 'emun.salesrep/week-activities'
import SalesRepSalesMonthly from 'emun.salesrep/salesrep-sales-monthly'
import TopSellingProducts from 'emun.salesrep/top-selling-products'
import TopSellingProductLines from 'emun.salesrep/top-selling-productlines'
import TopSellingCategories from 'emun.salesrep/top-selling-categories'
import TopSellingSubCategories from 'emun.salesrep/top-selling-subcategories'
import TopSellingProductRepOrderCount from 'emun.salesrep/top-selling-product-rep-order-count'
import SalesRepMonthlyGoals from 'emun.salesrep/salesrep-monthly-goals'
import SalesRepGoalsPrompt from 'emun.salesrep/salesrep-goals-prompt'
import DesignApprovalOrders from 'emun.salesrep/designapproval-orders'
import PaymentRequestOrders from 'emun.salesrep/paymentrequest-orders'
import ProductSales from 'emun.salesrep/product-sales'
import SalesRepSalesCategory from 'emun.salesrep/salesrep-sales-category'
import SalesRepSalesVendor from 'emun.salesrep/salesrep-sales-vendor'
import SalesRepSalesGoalsChart from 'emun.salesrep/salesrep-sales-goals-chart'
import SalesRepSalesGoalsCategory from 'emun.salesrep/salesrep-sales-goals-category'
import SalesRepSalesGoalsCategoryNew from 'emun.salesrep/salesrep-sales-goals-category-new'
import SalesRepSalesSource from 'emun.salesrep/salesrep-sales-source'
import SalesRepSalesShowCode from 'emun.salesrep/salesrep-sales-show-code'
import SalesRepSalesGoals from 'emun.salesrep/salesrep-sales-goals'
import SalesRepSalesGoalsFull from 'emun.salesrep/salesrep-sales-goals-full'
import SalesRepNotes from 'emun.salesrep/salesrep-notes'
import NewCustomerVendorCount from 'emun.salesrep/new-customer-vendor-count'
import SalesRepRetailerHoldOrders from 'emun.salesrep/salesrep-retailer-hold-orders'
import SalesRepPendingOrders from 'emun.salesrep/salesrep-pending-orders'
import ManagerGroupDashboard from 'emun.salesrep/managergroup-dashboard'
import SalesRepGroupDashboard from 'emun.salesrep/salesrepgroup-dashboard'
import SalesBySegment from 'emun.salesrep/sales-by-segment'
import NetRetailerGrowth from 'emun.salesrep/net-retailer-growth'
import InsideSalesCount from 'emun.salesrep/inside-sales-count'
import DashboardTotalsStatus from 'emun.salesrep/dashboard-totals-status'
import DashboardTotalsStatusTable from 'emun.salesrep/dashboard-totals-status-table'
import DivisionList from 'emun.salesrep/territory-manager/division/division-list'
import RegionList from 'emun.salesrep/territory-manager/region/region-list'
import RegionEdit from 'emun.salesrep/territory-manager/region/region-edit'
import DivisionEdit from 'emun.salesrep/territory-manager/division/division-edit'
import TerritoryList from 'emun.salesrep/territory-manager/territory/territory-list'
import TerritoryEdit from 'emun.salesrep/territory-manager/territory/territory-edit'
import ZipcodeList from 'emun.salesrep/territory-manager/zipcode/zipcode-list'
import RepGroupList from 'emun.salesrep/territory-manager/repgroup/repgroup-list'
import RepGroupEdit from 'emun.salesrep/territory-manager/repgroup/repgroup-edit'
import MarketList from 'emun.salesrep/market-list'
import SalesRepCustomerRetention from 'emun.salesrep/salesrep-customer-retention'
import RepAssignmentList from 'emun.salesrep/territory-manager/repassignment/repassignment-list'
import SubrepList from 'emun.salesrep/subrep-list'
import SubrepEdit from 'emun.salesrep/subrep-edit'
import CustomerTotalsVendor from 'emun.salesrep/customer-totals-vendor'
import HardcodeList from 'emun.salesrep/hardcode-manager/hardcode-list'

const deps = [
  'emun.auth',
  'webutils',
  'webforms',
  'webmodals',
  'emun.retailer',
  'ui.router'];

let mod = angular.module('emun.salesrep', deps)
	.component('salesrepContainer', SalesRepContainer)
	.component('salesrepList', SalesRepList)
	.component('salesrepDashboard', SalesRepDashboard)
	.component('subrepDashboard', SubRepDashboard)
	.component('b2bDashboard', b2bDashboard)
	.component('managerContainer', ManagerContainer)
	.component('insideSalesContainer', InsideSalesContainer)
	.component('managerList', ManagerList)
	.component('insideSalesList', InsideSalesList)
	.component('salesrepRecentOrders', SalesRepRecentOrders)
	.component('salesrepReviewOrders', SalesRepReviewOrders)
	.component('creditholdOrders', CreditHoldOrders)
	.component('creditholdCorporateOrders', CreditHoldCorporateOrders)
	.component('creditreviewOrders', CreditReviewOrders)
	.component('pastdueInvoices', PastDueInvoices)
	.component('customersPastdue', CustomersPastDue)
	.component('managerDashboard', ManagerDashboard)
	.component('syncDashboard', SyncDashboard)
	.component('salesrepSalesGoalsLastYearChart', SalesRepSalesGoalsLYChart)
	.component('salesrepShipmentsGoalsLastYearChart', SalesRepShipmentsGoalsLYChart)
	.component('salesrepSalesGoalsVendor', SalesRepSalesGoalsVendor)
	.component('salesrepTopCustomers', SalesRepTopCustomers)
	.component('salesrepTopCommitments', SalesRepTopCommitments)
	.component('topCustomersFull', TopCustomersFull)
	.component('salesrepTopUnderperformers', SalesRepTopUnderperformers)
	.component('salesrepExpectedOrders', SalesRepExpectedOrders)
	.component('salesrepExpectedOrdersFuture', SalesRepExpectedOrdersFuture)
	.component('salesrepSalesSourceQuarter', SalesRepSalesSourceQuarter)
	.component('salesrepSalesCategoryQuarter', SalesRepSalesCategoryQuarter)
	.component('salesrepProjectedBookings', SalesRepProjectedBookings)
	.component('salesrepProjectedBookingsThisweek', SalesRepProjectedBookingsThisWeek)
	.component('executiveDashboard', ExecutiveDashboard)
	.component('showroomDashboard', ShowroomDashboard)
	.component('salesrepShowroomDashboard', SalesrepShowroomDashboard)
	.component('repgroupDashboard', RepGroupDashboard)
	.component('insideSalesDashboard', InsideSalesDashboard)
	.component('marketDashboard', MarketDashboard)
	.component('managerActionsRep', ManagerActionsRep)
	.component('showAppointmentProjections', ShowAppointmentProjections)
	.component('showDailyAppointments', ShowDailyAppointments)
	.component('showHourlyAppointments', ShowHourlyAppointments)
	.component('showDailyComparison', ShowDailyComparison)
	.component('managerReps', ManagerReps)
	.component('salesrepSalesMonthly', SalesRepSalesMonthly)
	.component('topSellingProductLines', TopSellingProductLines)
	.component('topSellingProducts', TopSellingProducts)
	.component('topSellingCategories', TopSellingCategories)
	.component('topSellingSubcategories', TopSellingSubCategories)
	.component('topSellingProductRepOrderCount', TopSellingProductRepOrderCount)
	.component('weekActivities', WeekActivities)
	.component('salesrepMonthlyGoals', SalesRepMonthlyGoals)
	.component('salesrepGoalsPrompt', SalesRepGoalsPrompt)
	.component('designapprovalOrders', DesignApprovalOrders)
	.component('paymentrequestOrders', PaymentRequestOrders)
	.component('productSales', ProductSales)
	.component('salesrepSalesCategory', SalesRepSalesCategory)
	.component('salesrepSalesVendor', SalesRepSalesVendor)
	.component('salesrepSalesGoalsChart', SalesRepSalesGoalsChart)
	.component('salesrepSalesGoalsCategory', SalesRepSalesGoalsCategory)
	.component('salesrepSalesGoalsCategoryNew', SalesRepSalesGoalsCategoryNew)
	.component('salesrepSalesSource', SalesRepSalesSource)
	.component('salesrepSalesShowCode', SalesRepSalesShowCode)
	.component('salesrepSalesGoals', SalesRepSalesGoals)
	.component('salesrepSalesGoalsFull', SalesRepSalesGoalsFull)
	.component('salesrepNotes', SalesRepNotes)
	.component('newCustomerVendorCount', NewCustomerVendorCount)
	.component('salesrepRetailerHoldOrders', SalesRepRetailerHoldOrders)
	.component('salesrepPendingOrders', SalesRepPendingOrders)
	.component('managergroupDashboard', ManagerGroupDashboard)
	.component('salesrepgroupDashboard', SalesRepGroupDashboard)
	.component('salesBySegment', SalesBySegment)
	.component('netRetailerGrowth', NetRetailerGrowth)
	.component('dashboardTotalsStatus', DashboardTotalsStatus)
	.component('dashboardTotalsStatusTable', DashboardTotalsStatusTable)
	.component('insideSalesCount', InsideSalesCount)
	.component('divisionList', DivisionList)
	.component('regionList', RegionList)
	.component('regionEdit', RegionEdit)
	.component('divisionEdit', DivisionEdit)
	.component('territoryList', TerritoryList)
	.component('territoryEdit', TerritoryEdit)
	.component('zipcodeList', ZipcodeList)
	.component('repgroupList', RepGroupList)
	.component('repgroupEdit', RepGroupEdit)
	.component('marketList', MarketList)
	.component('hardcodeList', HardcodeList)
  .component('salesrepCustomerRetention', SalesRepCustomerRetention)
  .component('repassignmentList', RepAssignmentList)
  .component('subrepList', SubrepList)
  .component('subrepEdit', SubrepEdit)
  .component('customerTotalsVendor', CustomerTotalsVendor);

custom(mod);

export default mod.name;

